import { PROGRAM_TYPES, SPORTS } from '../data/dimensions';

export const COMBO_COUNT = SPORTS.length * PROGRAM_TYPES.length;
export const comboSport = (k: number) => Math.floor(k / PROGRAM_TYPES.length);
export const comboProgram = (k: number) => k % PROGRAM_TYPES.length;
